module.exports = __webpack_public_path__ + "static/media/Istore.f65972f2.svg";